<template>
  <div ref="monitoringContent" class="infrared-thermography container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入设备名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        default-expand-all
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <div class="pagination-table-container">
          <el-table :data="tableData"
                    ref="table"
                    border highlight-current-row
                    element-loading-background="rgba(255, 255, 255, 0.8)"
                    element-loading-spinner="el-icon-loading"
                    element-loading-text="努力加载中..."
                    style="width: 100%"
                    :span-method="objectSpanMethod"
                    @current-change="handleTableCurrentChange">
            <!--          <el-table-column type="selection" width="40"></el-table-column>-->
<!--            <el-table-column label="序号" type="index" width="60"></el-table-column>-->
            <el-table-column width="60" label="序号">
              <template slot-scope="scope">{{ scope.row.groupNum }}</template>
            </el-table-column>
<!--            <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">-->
<!--              <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>-->
<!--            </el-table-column>-->
            <el-table-column label="设备名称/位置" prop="auxMonitoringDeviceId" width="160" style="white-space: pre-wrap;">
              <template slot-scope="scope">{{ getNameById(scope.row.auxMonitoringDeviceId, auxMonitoringDevices)
                + '/' + scope.row.installationPlace}}</template>
            </el-table-column>
            <el-table-column label="红外图像" prop="pictureUrl1" width="500">
              <template slot-scope="scope"><el-image style="width:100%;height:100%;border:none;" fit="fill" :src="scope.row.pictureUrl1"></el-image></template>
            </el-table-column>
            <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="数值" prop="guagedValue" width="120">
              <template slot-scope="scope">
                {{$type.getResourceWorkStateText(scope.row.resourceKind, scope.row.gaugedObjectKind, scope.row.guagedValue, scope.row.realValue, scope.row.scaleFactor, scope.row.correctedValue, scope.row.valueType, scope.row.decimalDigit, scope.row.dataUnit)}}
              </template>
            </el-table-column>
            <el-table-column label="数值更新时间" prop="guagedTime" width="180">
              <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.guagedTime)}}</template>
            </el-table-column>
            <el-table-column label="告警状态" prop="alarmState" width="100">
              <template slot-scope="scope">
                <el-tag :type="tagTypeFromResourceAlarmState(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, scope.row.deployed, scope.row.encoderAlarmState, scope.row.encoderEventTypeSet)">
                  {{$type.getResourceAlarmStateText(scope.row.resourceKind, scope.row.alarmState, scope.row.eventTypeSet, scope.row.deployed, scope.row.encoderAlarmState, scope.row.encoderEventTypeSet)}}
                </el-tag>
              </template>
            </el-table-column>
<!--            <el-table-column label="事件触发时间" prop="happenTime" width="180">-->
<!--              <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="正常区间" prop="" width="120">-->
<!--              <template slot-scope="scope"> {{$type.getDataNodeAlarmRuleText(scope.row)}}</template>-->
<!--            </el-table-column>-->
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  class="col-btn"
                  type="text"
                  icon="el-icon-view"
                  @click="handleDataNodeView(scope.row)"
                >查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination v-show="tableTotalRow > tableQueryParams.pageSize"
                         background
                         @current-change="handleCurrentPageChange"
                         @size-change="handlePageSizeChange"
                         :current-page.sync="tableQueryParams.pageNum"
                         :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                         :page-size.sync="tableQueryParams.pageSize"
                         prev-text="上一页"
                         next-text="下一页"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="tableTotalRow">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--显示数据节点信息-->
    <show-data-node v-if="showDataNodeModalOpen" :modalOpen="showDataNodeModalOpen" :dataNode="tableCurrentRow" @cancel="handleShowDataNodeModalCancel"></show-data-node>

  </div>
</template>

<script type="text/ecmascript-6">
import InfraredThermography from './InfraredThermography.js'

export default InfraredThermography
</script>

<style lang="scss">
  // @import "InfraredThermography.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/infraredThermography/InfraredThermography.vue